import { FC, useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ActionCell from 'components/actions/ActionCell';
import { useTranslation } from 'react-i18next';
import { IMultiActionsByCategory } from '../types';

interface IProps {
  data: IMultiActionsByCategory;
  methods: any;
  hasPermission?: boolean;
}

const DefaultActions: FC<IProps> = ({ data, methods, hasPermission }) => {
  const [approve, setApprove] = useState(data.approve);
  const [sign, setSign] = useState(data.sign);

  const { t } = useTranslation();

  useEffect(() => {
    setApprove(data.approve);
    setSign(data.sign);
  }, [data]);

  const maxApprovePositionsAvailable: number = data.approve_options.reduce((optionCount, group) => {
    const optionsLength = group?.options?.length || 0;
    return optionCount + optionsLength;
  }, 0);

  const maxSignPositionsAvailable: number = data.sign_options.reduce((optionCount, group) => {
    const optionsLength = group?.options?.length || 0;
    return optionCount + optionsLength;
  }, 0);
  return (
    <Row className="mt-5 mb-5 text-center text-md-left">
      <Col md={7}>
        <h3 className="h5">{data?.category_name}</h3>
        <p>
          <i>{t('structure.multiActions.defaultBehaviour')}</i>
        </p>
      </Col>
      <Col md={5}>
        <Row className="d-block pr-3 mt-3 mt-md-0">
          <div className="d-flex text-center text-md-left">
            <div
              className="pr-2"
              style={{ flex: 1 }}
            >
              <ActionCell
                title={t('structure.multiActions.approvals')}
                name="default-approve"
                options={data.approve_options}
                maxPositionsAvailable={maxApprovePositionsAvailable}
                selected={approve}
                methods={methods}
                updateData={actionData => {
                  setApprove(actionData);
                }}
                hasPermission={hasPermission}
              />
            </div>
            <div
              className="pl-3 pr-2"
              style={{ flex: 1 }}
            >
              <ActionCell
                title={t('structure.multiActions.signatures')}
                name="default-sign"
                options={data.sign_options}
                maxPositionsAvailable={maxSignPositionsAvailable}
                selected={sign}
                methods={methods}
                updateData={actionData => {
                  setSign(actionData);
                }}
                hasPermission={hasPermission}
              />
            </div>
          </div>
        </Row>
      </Col>
    </Row>
  );
};

export default DefaultActions;
